module.exports = __webpack_public_path__ + "static/media/entry-promotion-hero.5d1a69db.jpg";